import React, { useState, useEffect } from "react";
import { token } from "../Actions/AuthAction";
import { getleads } from "../Actions/LeadAction";

const LeadDashboard = (props) => {
  const [opt, setOpt] = useState("recruitment outsourcing");
  const [data, usedata] = useState([]);
  useEffect(() => {
    getData(opt);
  }, []);

  const getData = (val) => {
    getleads({ key: token(), lead: val }).then((res) => {
      usedata(res.data);
    });
  };
  return (
    <>
      <div className="row mb-4">
        <div className="col-md-12">
          <h4 className="table_heading position-relative">
            PG Accomodation Enquiry LIST
          </h4>
        </div>
      </div>
      <div className="card table_card mb-4">
        <div className="card-body">
          <div className="">
            <form className="d-flex justify-content-between form-group tableform">
              <div>
                <select
                  className="form-control"
                  value={opt}
                  onChange={(e) => {
                    setOpt(e.target.value);
                    getData(e.target.value);
                  }}
                >
                  <option value="campus placement solution">
                    "campus placement solution"
                  </option>
                  <option value="contractualstaffing">
                    "contractualstaffing"
                  </option>
                  <option value="employeemanagement">
                    "employeemanagement"
                  </option>
                  <option value="full time hiring">"full time hiring"</option>
                  <option value="recruitment outsourcing">
                    "recruitment outsourcing"
                  </option>
                </select>
              </div>
              <div className="search-box mb-2">
                <input
                  className="search-text"
                  type="text"
                  placeholder="Search in table"
                />
                <a href="#" className="search-btn">
                  <i className="fas fa-search"></i>
                </a>
              </div>
            </form>
          </div>
          <div className="table-responsive">
            <table
              className="table table-bordered"
              width="100%"
              cellspacing="0"
            >
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Name</th>
                  <th>Mobile Number</th>
                  <th>Email Id</th>

                  <th>Message</th>
                </tr>
              </thead>
              <tbody>
                {data == undefined ? (
                  <h4>No Data Found</h4>
                ) : data.length == 0 ? (
                  <h4>Loading</h4>
                ) : (
                  data.map((item) => (
                    <tr>
                      <td>{item.id}</td>
                      <td>{item.name}</td>
                      <td>{item.contactnumber}</td>
                      <td>{item.email}</td>
                      <td>{item.message}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {/* <div className="d-flex justify-content-between">
              <h6>
                <span>{`${
                  this.state.currentPage
                    ? this.state.currentPage * this.state.limit + 1
                    : 1
                }-${
                  data.length < limit
                    ? totalCount
                    : (this.state.currentPage + 1) * this.state.limit
                }`}</span>{" "}
                <span>/ {this.state.totalCount} Search Results</span>
              </h6>
              <div class="pagination">
                <ReactPaginate
                  previousLabel={
                    <i
                      className="fa fa-angle-double-left"
                      aria-hidden="true"
                    ></i>
                  }
                  nextLabel={
                    <i
                      className="fa fa-angle-double-right"
                      aria-hidden="true"
                    ></i>
                  }
                  pageCount={
                    this.state.totalCount % this.state.limit === 0
                      ? parseInt(this.state.totalCount / this.state.limit)
                      : parseInt(this.state.totalCount / this.state.limit) + 1
                  }
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={10}
                  onPageChange={this.handlePageClick}
                  activeClassName={"active"}
                />
              </div>
            </div> */}
        </div>
      </div>
    </>
  );
};
export default LeadDashboard;
